import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Drawer, CssBaseline, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import "./MobileMiniDrawer.css";
import CarryMyPet from "../../../images/cmp_logo_minidrawer.svg";
import Vector from "../../../images/Vector.svg";
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

const drawerWidth = 240;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between", // Adjusted to space between logo and close icon
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export default function MobileMiniDrawer({ onClose }) { // Accept the onClose prop
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  // Responsive breakpoints for laptop (lg) and tablet (md)
  const isLaptop = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));

  // Drawer width adjustments based on screen size
  const drawerWidth = isLaptop ? 240 : isTablet ? 180 : 210;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            transition: "width 0.9s ease-in-out", // Smooth transition for drawer width
          },
        }}
      >
        {/* Drawer Header */}
        <DrawerHeader className="DrawerHeader" style={{ background: "#F15843" }}>
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
            }}
          >
            <img
              alt="Loading..."
              className="form-image-MiniDrawer"
              src={CarryMyPet}
              onClick={() => navigate("/Dashboard")}
              style={{
                position: "relative", left: "5px", top: "11px", cursor: "pointer", height: "74px",
                width: "70px"
              }}
            />
          </ListItemIcon>
          {/* Close Icon */}
          <IconButton onClick={onClose} sx={{ color: 'white',top: "11px" }}>
            <CloseIcon />
          </IconButton>
        </DrawerHeader>

        {/* Order Summary */}
        <List className={`${open ? "activeList" : ""} mainDashboard`}>
          <ListItem key="OrderSummary" disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <ListItemText
                  className="minidrawer-itemtext"
                  primary="Order Summary"
                  sx={{ opacity: open ? 1 : 0 }}
                  style={{
                    flexGrow: 1,
                    marginRight: '8px',
                    textAlign: open ? "left" : "center",
                  }}
                />
                <img
                  style={{
                    width: isLaptop ? "7px" : "5px",
                    cursor: "pointer",
                    transition: '0.3s ease-in-out',
                  }}
                  alt="Loading..."
                  className="form-image-MiniDrawer"
                  src={Vector}
                />
              </div>
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
    </Box>
  );
}
